<template>
  <v-container class="d-flex flex-column px-10" fluid>
    <loader :loading="loading"></loader>
    <v-alert
      class="error"
      id="error"
      type="info"
      dense
      icon="mdi-information-outline"
      v-if="errorSummary !== null"
      >{{ errorSummary }}
    </v-alert>
    <v-layout row wrap align-left class="text-left">
      <v-flex>
        <p class="text-bold neutral--text pt-6">{{ $t('reset-password') }}</p>
        <p class="text-light neutral--text">{{ $t('reset-password-message') }}</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center>
      <v-flex>
        <v-form
          class="auth-form text-left"
          ref="form"
          :lazy-validation="true"
          fluid
          @submit.prevent="submit"
        >
          <label class="text-bold subtitle-2">{{ $t('email') }}</label>
          <v-text-field
            data-cy="email"
            v-model="email"
            :placeholder="$t('email')"
            type="text"
            :rules="emailRules()"
            outlined
            class="pt-1"
          ></v-text-field>
        </v-form>
        <v-btn
          color="primary200"
          :disabled="loading"
          data-cy="login"
          large
          width="200"
          @click="submit"
          class="rounded-lg white--text mb-6 mt-5"
          >{{ $t('reset-password') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus';
import Loader from '@/components/shared/helpers/Loader.vue';
import Vue from 'vue';

export default {
  name: 'ForgotPassword',
  mixins: [util],
  components: {
    Loader,
  },
  data: () => ({
    loading: false,
    email: null,
    rememberMe: true,
    responseStatus: null,
    errorSummary: null,
  }),
  methods: {
    submit() {
      this.errorSummary = null;
      this.$refs.form.validate();
      if (!this.email) {
        return;
      }
      this.loading = true;
      let emailDto = {};
      emailDto.email = this.email;
      this.axios
        .post('/api/v1/auth/forgot-password', emailDto)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('snackbar.reset-link'),
          });
          setTimeout(() => {
            const basePath = window.location.origin.toString();
            Vue.$keycloak.login({ redirectUri: basePath });
          }, '2000');
        })
        .catch(error => {
          if (error.request && error.response.status === 400) {
            this.errorSummary = this.$i18n.t(error.response.data.description);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
